import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBase',
  props: {
	valueSingle: {
		type: [Object, null] as PropType<any | null | undefined>,
	},
	valueMulti: {
		type: [Array, null] as PropType<any[] | null | undefined>,
	},
	ajax: {
		type: Boolean,
		default: false,
	},
	/* options: {
		type: Array as PropType<any[]>,
		required: true,
	}, */
	/* selectedOptions: {
		type: Array as PropType<any[]>,
		required: true,
	}, */
	/* objectKeyProp: {
		type: String,
		required: true,
	}, */
	avatar: {
		type: Boolean,
		default: false,
	},

	isInvalid: {
		type: Boolean,
		default: undefined,
	},

	id: {
		type: String,
	},

	optionGenerator: {
		type: Function as PropType<(option: any) => any>,
		required: true,
	},
	optionComparer: {
		type: Function as PropType<(a: any) => any>,
		required: true,
	},
	optionLoader: {
		type: Function as PropType<(search?: string, page?: number) => Promise<any[]>> | undefined,
		required: false,
	},
	options: {
		type: Array as PropType<any[]>,
	},
	placeholder: {
		type: String,
	},
},
  emits: ["update:valueSingle", "update:valueMulti", "search", "remove", "blur"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const cValueSingle = computed({
	get: () => props.valueSingle,
	set: (value) => emit("update:valueSingle", value),
});

const cValueMulti = computed({
	get: () => props.valueMulti || [],
	set: (value) => emit("update:valueMulti", value),
});

return (_ctx: any,_cache: any) => {
  const _component_HakoSingleSelect2 = _resolveComponent("HakoSingleSelect2")!
  const _component_HakoMultiselect2 = _resolveComponent("HakoMultiselect2")!

  return (__props.valueSingle !== undefined)
    ? (_openBlock(), _createBlock(_component_HakoSingleSelect2, {
        key: 0,
        modelValue: cValueSingle.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cValueSingle).value = $event)),
        useAvatar: __props.avatar,
        useAjax: __props.ajax,
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur'))),
        isInvalid: __props.isInvalid,
        id: __props.id,
        optionGenerator: __props.optionGenerator,
        optionComparer: __props.optionComparer,
        optionLoader: __props.optionLoader,
        options: __props.options,
        useWindowMenu: "",
        placeholder: __props.placeholder,
        startSearchLimit: 0
      }, {
        default: _withCtx(({ openMenu }) => [
          _renderSlot(_ctx.$slots, "default", { openMenu: openMenu })
        ]),
        _: 3
      }, 8, ["modelValue", "useAvatar", "useAjax", "isInvalid", "id", "optionGenerator", "optionComparer", "optionLoader", "options", "placeholder"]))
    : (__props.valueMulti !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_HakoMultiselect2, {
            modelValue: cValueMulti.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cValueMulti).value = $event)),
            useAvatar: __props.avatar,
            useAjax: __props.ajax,
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur'))),
            isInvalid: __props.isInvalid,
            id: __props.id,
            optionGenerator: __props.optionGenerator,
            optionComparer: __props.optionComparer,
            optionLoader: __props.optionLoader,
            options: __props.options,
            useWindowMenu: "",
            placeholder: __props.placeholder,
            startSearchLimit: 0
          }, {
            default: _withCtx(({ openMenu }) => [
              _renderSlot(_ctx.$slots, "default", { openMenu: openMenu })
            ]),
            _: 3
          }, 8, ["modelValue", "useAvatar", "useAjax", "isInvalid", "id", "optionGenerator", "optionComparer", "optionLoader", "options", "placeholder"])
        ]))
      : _createCommentVNode("", true)
}
}

})